export default __webpack_public_path__ + "static/media/IMG_1978.1f41f4fc.jpg";